
import React from 'react'
import 'less/edit-survey-id-modal.less'
import Select from 'react-select'
import { parseTimeZone } from 'assets/localization'
import { timezone, timezoneAbbreviationLabel } from 'shared/helpers/user'
import { fillTimezoneLabel } from 'shared/helpers/functional'


const TimezoneSelect = props => {
    const timezoneValues = Array.from(timezone, ([key, value]) => {
      return {
          value: key, 
          label: `${fillTimezoneLabel(key)} ${value} - ${timezoneAbbreviationLabel(key)} `
        }
    });

    const close = () => {
        const timer = setTimeout(() => { //  In order to prevent changing the timeZone and posting an availability  in the same time the timeOut is added. After 0.5 s the action is dipatched. 
            props.onClose()
          }, 500);
          return () => clearTimeout(timer);
    }

    return (
        <div className='timezone-select'>
            <Select
                searchable={props.searchable}
                value={props.value}
                options={timezoneValues}
                placeholder={props.placeholder}
                onChange={props.onChange}
                clearable={props.clearable}
                onOpen={props.onOpen ? props.onOpen : ''}
                onClose={props.onClose ? close : ''}
            />
        </div>
    )
}

export default TimezoneSelect
